/**
 * Generates a deterministic hash from a string (player name)
 * Used to create consistent avatar seeds for players
 */
export function generateAvatarSeed(name: string): number {
  let hash = 0;
  for (let i = 0; i < name.length; i++) {
    const char = name.charCodeAt(i);
    hash = ((hash << 5) - hash) + char;
    hash = hash & hash; // Convert to 32-bit integer
  }
  return Math.abs(hash);
}

/**
 * Generates an avatar URL for a player based on their name
 * @param name - Player name
 * @param size - Avatar size in pixels (default: 48)
 * @param baseUrl - Avatar API base URL
 */
export function getAvatarUrl(name: string, size: number = 48, baseUrl: string): string {
  const seed = generateAvatarSeed(name);
  return `${baseUrl}/?seed=${seed}&size=${size}`;
}
